import { render, staticRenderFns } from "./CurrentAlarmSocket.vue?vue&type=template&id=2d05dfcf&scoped=true&"
import script from "./CurrentAlarmSocket.vue?vue&type=script&lang=js&"
export * from "./CurrentAlarmSocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d05dfcf",
  null
  
)

export default component.exports